import { useAtom } from "jotai";

import { MMMClientAtom, useGlobalMMMStore } from "../mmm-provider";

export const useMMMClient = () => {
  const GlobalMMMStore = useGlobalMMMStore();
  const [mmmClient, setMMMClient] = useAtom(MMMClientAtom, {
    store: GlobalMMMStore,
  });

  return [mmmClient, setMMMClient] as const;
};
